import React, { useMemo } from 'react'
import { TableProps } from 'antd/lib/table/Table'
import { Table } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { FilterValue } from 'antd/es/table/interface'
import styles from './CustomTable.module.scss'
import { ITableState, SortEnum } from '@utils/sort'
import { IconEdit, IconTrash } from '@utils/icons'
import TooltipUi from '../TooltipUi/TooltipUi'

interface Props extends TableProps<any> {
  columns: ColumnsType<any> | undefined
  dataSource: any[]
  editTitle?: string
  allCount?: number
  customKey?: string
  updatePagination?: React.Dispatch<React.SetStateAction<ITableState>>
  delAction?: (val: string) => void
  editAction?: (val: string) => void
  menuAction?: (val: string) => React.ReactNode
}

const CustomTable: React.FC<Props> = ({
  delAction,
  editAction,
  updatePagination,
  allCount = 0,
  columns,
  pagination,
  dataSource,
  menuAction,
  editTitle,
  ...props
}) => {
  const mappedData = useMemo(() => {
    return dataSource && (delAction || editAction || menuAction)
      ? dataSource.map((el) => ({
          ...el,
          action: (
            <div className={styles.actions}>
              {editAction && (
                <TooltipUi title='Редактировать'>
                  <span className={styles.edit} onClick={() => editAction(el.id)}>
                    <IconEdit width='20' height='20' fill='var(--color-blue)' />
                  </span>
                </TooltipUi>
              )}
              {delAction && (
                <TooltipUi title='Удалить'>
                  <span className={styles.del} onClick={() => delAction(el.id)}>
                    <IconTrash width='20' height='20' fill='var(--color-red)' />
                  </span>
                </TooltipUi>
              )}
              {menuAction && menuAction(el.id)}
            </div>
          ),
        }))
      : dataSource
  }, [dataSource, delAction, editAction, menuAction])

  const mappedColumns = useMemo(() => {
    const mapped = columns?.map((el) => ({
      ...el,
      width: el.width ?? `${100 / columns.length}%`,
    }))
    return mapped && (delAction || editAction || menuAction)
      ? [
          ...mapped,
          {
            title: editTitle ?? 'Редактировать',
            dataIndex: 'action',
            fixed: 'right' as const,
            width: '10%',
          },
        ]
      : mapped
  }, [columns, delAction, editAction])

  const changeHandler = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: any,
  ) => {
    updatePagination &&
      updatePagination((prev: ITableState) => ({
        ...prev,
        sort: {
          sort: sorter?.order ? (sorter.order === 'ascend' ? SortEnum.asc : SortEnum.desc) : null,
          field: sorter?.field ? sorter.field : null,
        },
        pagination: {
          current: pagination?.current ?? prev.pagination.current,
          pageSize: pagination?.pageSize ?? prev.pagination.pageSize,
        },
      }))
  }

  return (
    <Table
      showSorterTooltip={false}
      className={styles.customTable}
      dataSource={mappedData}
      columns={mappedColumns}
      rowKey='key'
      pagination={
        pagination
          ? {
              ...pagination,
              pageSizeOptions: [5, 10, 20, 50],
              showSizeChanger: true,
              total: allCount,
            }
          : false
      }
      onChange={changeHandler}
      {...props}
    />
  )
}

export default CustomTable
